var ProtocoloAgrupamentoPost = /** @class */ (function () {
    function ProtocoloAgrupamentoPost(id) {
        this.id = id;
    }
    return ProtocoloAgrupamentoPost;
}());
export { ProtocoloAgrupamentoPost };
